<script>
import CoreDrawer from '@components/core-drawer'
import CoreToolbar from '@components/core-toolbar'
import CoreSnackbar from '@components/core-snackbar'

export default {
  components: { CoreDrawer, CoreToolbar, CoreSnackbar },
}
</script>

<template>
  <VApp>
    <CoreDrawer />

    <CoreToolbar />

    <!-- VContent -->
    <VContent>
      <VContainer fluid>
        <VLayout>
          <VFlex xs12>
            <section>
              <VSlideXTransition mode="out-in">
                <RouterView />
              </VSlideXTransition>
            </section>
          </VFlex>
        </VLayout>
      </VContainer>
    </VContent>
    <!-- End of VContent -->

    <CoreSnackbar />
  </VApp>
</template>
